import Panel from '../components/panel.tsx'
import {Button} from '../components/button.tsx'
import { useStore } from "../state/state.ts";
import { ModalClose } from '../components/modal-close.tsx';


export default function ModalInfoWarmwasserReferenz() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const heizung_future = useStore((state)=>state.heizung_future);

  return (<Panel >
            <h1 id="modal-title">Warmwasserreferenz</h1>
            <p id="modal-description"> Die Berechnung findet unter der Annahme statt, dass die Warmwasser Bereitung über die Heizung erfolgt.</p>
             <ModalClose label={"weiter"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

